"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizationContext = exports.OrganizationContext = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "OrganizationContext", { enumerable: true, get: function () { return shared_1.OrganizationContext; } });
Object.defineProperty(exports, "useOrganizationContext", { enumerable: true, get: function () { return shared_1.useOrganizationContext; } });
